import { render, staticRenderFns } from "./TasksBreadcrumb.vue?vue&type=template&id=77367b10&scoped=true"
import script from "./TasksBreadcrumb.vue?vue&type=script&lang=js"
export * from "./TasksBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./TasksBreadcrumb.vue?vue&type=style&index=0&id=77367b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77367b10",
  null
  
)

export default component.exports